// import request from '@/utils/request'
import axios from 'axios'
let request = ({ url, method = 'post', data = {} }) => {
  let headers = {}
  let jwt = window.localStorage.getItem('teacher-jwt')
  // let uid = window.localStorage.getItem('teacher-uid')
  headers['Authorization'] = `bearer ${jwt}`
  return axios({
    // baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://yoteach-cloud.herokuapp.com',
    baseURL: 'https://yoteach-cloud.herokuapp.com',
    url,
    headers,
    method,
    data
  })
}

/*
data: Form Data
*/
export function addQuestion (data) {
  return request({
    url: '/jwt/question/add',
    method: 'post',
    data
  })
}

export function addQuestionBatch (data) {
  return request({
    url: '/jwt/question/add-batch',
    method: 'post',
    data
  })
}

export function listFolderQuestion (data) {
  return request({
    url: '/jwt/question/list-folder',
    method: 'post',
    data
  })
}

export function getQuestion (data) {
  return request({
    url: '/jwt/question/detail',
    method: 'post',
    data
  })
}

export function getQuestionOnly (data) {
  return request({
    url: '/jwt/question/question-only',
    method: 'post',
    data
  })
}

export function getRandomQuestion (data) {
  return request({
    url: '/jwt/question/random-question',
    method: 'post',
    data
  })
}

export function removeQuestion (data) {
  return request({
    url: '/jwt/question/remove-this',
    method: 'post',
    data
  })
}

export function updateQuestion (data) {
  return request({
    url: '/jwt/question/update-this',
    method: 'post',
    data
  })
}

// export function matchQuestionTags({ tags }) {
//   return request({
//     url: '/jwt/question/match-tags',
//     method: 'post',
//     data: {
//       tags
//     }
//   })
// }
